<template>
    <div class="page-text--sm w-100">
        <v-img :src="src" class="w-100 mb-12 mb-lg-18"></v-img>
        <p class="color-grey-7" v-if="sc1" data-aos="fade-down">
            {{sc1}}
        </p>
        <p class="font-weight-bold" v-if="sc2" data-aos="fade-up">
            {{sc2}}
        </p>
        <slot/>
    </div>
</template>

<script>

export default{
    props : {
        src : {type :String, default : ""},
        sc1 : {type :String, default : ""},
        sc2 : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>

</style>